import { QueryClient } from '@tanstack/react-query'

// One shared cache for every server-data query. Invalidated by
// `useEventStream` on live domain/notification events instead of a fixed
// refetch interval — a stale cache waits for the next explicit invalidation
// or navigation-triggered refetch, not a timer.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})
